import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { ProjectFinancementDetailsDto } from 'app/modules/models/projectFinancement.type';
import { CreatePrepareProjectRequest } from '../projectFinancementBody';

@Injectable({
  providedIn: 'root'
})
export class CreationProjetService {
  protected apiRoute = environment.RESOURCE_API;

  constructor(private _httpClient: HttpClient) { }

  depotProjectFinancement(
    companyId: string,
    partnerId: string,
    projectFinancementFilesBody: any,
    mandateId?: string | null,
    isImportedSignedDevis: boolean = false
  ): Observable<any> {
    const baseUrl =
      this.apiRoute +
      environment.apiCatalog.projectFinancement.controllerRoute +
      environment.apiCatalog.projectFinancement.subRoutes.depotProjectFinancement;

    // Construction dynamique des query params
    let params = new HttpParams()
      .set('companyId', companyId)
      .set('partnerId', partnerId)
      .set('isImportedSignedDevis', isImportedSignedDevis);

    if (mandateId) {
      params = params.set('mandateId', mandateId);
    }

    return this._httpClient.post<any>(baseUrl, projectFinancementFilesBody, {
      params,
      headers: new HttpHeaders({
      }),
    });
  }

  createPrepareProject(request: CreatePrepareProjectRequest
  ): Observable<any> {
    const baseUrl =
      this.apiRoute +
      environment.apiCatalog.projectFinancement.controllerRoute +
      environment.apiCatalog.projectFinancement.subRoutes.createPrepareProject;

    // Construction dynamique des query params
    let params = new HttpParams()
      .set('companyId', request.companyId)
      .set('partnerId', request.partnerId)
      .set('partnerName', request.partnerName || '')
      .set('isImportedSignedDevis', request.isImportedSignedDevis);


    if (request.mandateId) {
      params = params.set('mandateId', request.mandateId);
      params = params.set('mandateName', request.mandateName || '');
    }

    const formDataToSubmit = request.projectFinancementFilesBody || new FormData();

    if (request.projectFinancementOperations && request.projectFinancementOperations.length > 0) {
      formDataToSubmit.append(
        'ProjectFinancementOperations', 
        JSON.stringify(request.projectFinancementOperations)
      );
    }

    return this._httpClient.post<any>(baseUrl, formDataToSubmit, {
      params,
      headers: new HttpHeaders({
      }),
    });
  }

  saveDovaAnalysis(
    projectId: string,
    companyId: string,
    partnerId: string,
    importedSignedDevis: boolean,
    projectFinancementFilesBody: any,
  ): Observable<any> {
    const baseUrl =
      this.apiRoute +
      environment.apiCatalog.projectFinancement.controllerRoute +
      environment.apiCatalog.projectFinancement.subRoutes.saveDovaAnalysis;

    // Construction dynamique des query params
    let params = new HttpParams()
      .set('projectId', projectId)
      .set('companyId', companyId)
      .set('partnerId', partnerId)
      .set('importedSignedDevis', importedSignedDevis);

    return this._httpClient.post<any>(baseUrl, projectFinancementFilesBody, {
      params,
      headers: new HttpHeaders({
      }),
    });
  }

  depotProjectFinancementDova(
    projectId: string,
    projectFinancementFilesBody: any,
  ): Observable<any> {
    const baseUrl =
      this.apiRoute +
      environment.apiCatalog.projectFinancement.controllerRoute +
      environment.apiCatalog.projectFinancement.subRoutes.depotProjectFinancementDova + projectId;

    return this._httpClient.put<any>(baseUrl, projectFinancementFilesBody, {
      headers: new HttpHeaders({
      }),
    });
  }

  depotDocumentProcessingDova(
    projectId: string,
    userId: string,
    projectFinancementFilesBody: any,
  ): Observable<any> {
    const baseUrl =
      this.apiRoute +
      environment.apiCatalog.projectFinancement.controllerRoute +
      environment.apiCatalog.projectFinancement.subRoutes.depotDocumentProcessingDova + projectId;

    let params = new HttpParams();
    if (userId) {
      params = params.set('userId', userId);
    }
    return this._httpClient.put<any>(baseUrl, projectFinancementFilesBody, {
      params,
      headers: new HttpHeaders({
      }),
    });
  }

  updateProjectFinancementDetail(
    projectId: string,
    projectFinancementDetails: ProjectFinancementDetailsDto,
  ): Observable<any> {
    const baseUrl =
      this.apiRoute +
      environment.apiCatalog.projectFinancement.controllerRoute +
      environment.apiCatalog.projectFinancement.subRoutes.updateProjectFinancementDetail + projectId;

    return this._httpClient.put<any>(baseUrl, projectFinancementDetails, {
      headers: new HttpHeaders({
      }),
    });
  }


  checkIfProjectExists(projectId: string): Observable<boolean> {
    const route = this.apiRoute + environment.apiCatalog.projectFinancement.controllerRoute + environment.apiCatalog.projectFinancement.subRoutes.checkIfProjectExists + projectId;
    return this._httpClient.get<boolean>(route, {
      headers: {
        // Do NOT set 'Content-Type'; let the browser set it with boundary
      }
    });
  }
}
